import { ReactNode } from "react";
import React from "react";

import Header from "@/components/organisms/header/Header";
import MenuLinkList from "@/components/organisms/mypage/MenuLinkList";
import { mypageMenus } from "@/models/mypage/mypage";

type Props = {
  children?: ReactNode;
  title?: string;
  menu?: ReactNode;
  className?: string;
};

const Layout = ({ children, title = "", className }: Props) => {
  return (
    <div className="flex min-h-screen bg-[#F1F1F1]">
      <div className="grow">
        <Header pageTitle={title} />
        <main className="px-4 pb-6 mx-auto mt-4 max-w-[1024px]">
          <div className="flex flex-col items-start space-x-0 sm:flex-row md:space-x-8">
            {/* TODO:登録ページから遷移の場合のみ表示 */}
            <div className="hidden basis-1/4 md:block">
              <h2 className="mb-10 text-xl font-bold">{title}</h2>
              <div className="bg-black/10">
                <MenuLinkList menus={mypageMenus} />
              </div>
            </div>
            <main className={["container", className].join(" ")}>
              {children}
            </main>
          </div>
        </main>
      </div>
    </div>
  );
};

export default Layout;
